import {AxiosInstance} from 'axios';
import {responseHandler} from './response';
import {FixtureModelParams, FixtureResponse} from "../../types/fixture";
import {ApiSportsEndPointResponse} from "./types";

export const getFixture = async (client: AxiosInstance, fixtureId: number) =>
    responseHandler<ApiSportsEndPointResponse<FixtureResponse>>(client.get(`/fixtures/${fixtureId}`))

export const getFixtures = async (client: AxiosInstance, params?: Partial<FixtureModelParams>) => {
    client.defaults.params = params
    return responseHandler<ApiSportsEndPointResponse<FixtureResponse>>(client.get(`/fixtures`))
}

export const getHeadToHeadFixtures = async (client: AxiosInstance, homeTeamId: number, awayTeamId: number) => {
    client.defaults.params = {
        homeTeamId,
        awayTeamId
    }
    return responseHandler<ApiSportsEndPointResponse<FixtureResponse>>(client.get(`/fixtures/headtohead`))
}